<button mat-icon-button type="button" [disabled]="disabled" (click)="_open($event)">
<!--  <mat-icon>bookmark_border</mat-icon>-->
  <svg xmlns="http://www.w3.org/2000/svg" class="mat-reference-picker-toggle-default-icon" height="24px" viewBox="0 0 24 24" width="24px" fill="currentColor">
    <path d="M0 0h24v24H0z" fill="none"/>
    <path d="M17 3H7c-1.1 0-1.99.9-1.99 2L5 21l7-3 7 3V5c0-1.1-.9-2-2-2zm0 15l-5-2.18L7 18V5h10v13z"/>
  </svg>
</button>
